import React, { useState, useEffect } from 'react';
import { useConfig } from '../context/ConfigContext';

const Footer = () => {
    const { config } = useConfig();
    const [cacheBuster] = useState(() => Date.now());
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const footerSrc = config?.footerImageUrl || config?.footerLogoUrl;

    const getCleanImageUrl = (url) => {
        if (!url) return '';
        return `${url}${url.includes('?') ? '&' : '?'}v=${cacheBuster}`;
    };

    return (
        <footer className="w-full py-4 sm:py-8 mt-4 relative z-10 flex flex-col items-center justify-center select-none">
            {footerSrc ? (
                <img
                    src={getCleanImageUrl(footerSrc)}
                    alt="Footer"
                    style={{
                        maxWidth: isMobile ? '110px' : '260px',
                        maxHeight: isMobile ? '38px' : '75px'
                    }}
                    className="w-auto h-auto object-contain opacity-95 hover:opacity-100 transition-all duration-300 pointer-events-none"
                />
            ) : (
                <div className="text-center opacity-80">
                    <span className="text-white text-xl font-black italic tracking-tighter">Pfizer</span>
                </div>
            )}
            <div className="mt-4 px-4 text-center text-xs text-white/80 max-w-2xl leading-relaxed space-y-1">
                <p>El contenido de este sitio es exclusivo para profesionales de la salud autorizados para prescribir y/o dispensar medicamentos.</p>
                <p>Está prohibida la reproducción o el intercambio con terceros.</p>
                <p>
                    Para obtener más información sobre Pfizer, visite el sitio web de su país:{' '}
                    <a
                        href="https://www.pfizer.com.pe/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline hover:text-white transition-colors pointer-events-auto"
                    >
                        Perú: https://www.pfizer.com.pe/
                    </a>
                </p>
                <p>PP-A1G-PER-0201</p>
            </div>
        </footer>
    );
};

export default Footer;
